// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Add Auth SDK

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCaYaPOEjm38do8XWRVc676GZG9JI62It0",
  authDomain: "dev-entropy-439018-n5.firebaseapp.com",
  projectId: "dev-entropy-439018-n5",
  storageBucket: "dev-entropy-439018-n5.firebasestorage.app",
  messagingSenderId: "334985246028",
  appId: "1:334985246028:web:cb1fe39f782fe88d7c8be9",
  measurementId: "G-31WNGEDCBD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); // Initialize Analytics
const auth = getAuth(app); // Initialize Auth

export { app, analytics, auth };